import React from "react";
import "./Loading.css";
import { useLoader } from "../../context/LoaderContext";
interface LoadingProps {
  show?: boolean;
}

const Loading: React.FC<LoadingProps> = () => {
  const { show } = useLoader(); 

  if (!show) {
    return null;
  }

  return (
    <div className="block-ui-container">
        <div className="block-ui-overlay" />
        <div className="block-ui-message-container">
          <div className="block-ui-message">
            <h5>Loading</h5>
            <div className="loading-indicator">
              <svg id="indicator" viewBox="0 0 100 100">
                <circle id="circle" cx="50" cy="50" r="50" />
              </svg>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Loading;